module.exports = __webpack_public_path__ + "static/logoadasol3-cf918371a8a5ad2b816b9d1b813badd6.ico";